import { CartModal } from "components/CartModal/CartModal";
import { ShoppingCartIcon } from "components/icons/ShoppingCartIcon";
import { LeftBarTag } from "components/Sidebar/LeftBar";
import { SidebarStickyItem } from "components/Sidebar/SidebarStickyItem";
import { OPEN_CHECKOUT } from "constants/analyticsEvents";
import { useAnalytics } from "hooks/useAnalytics";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useModal } from "hooks/useModal";
import { stopPropagation } from "utils/stopPropagation";
import { useGetEntitiesCartTotalQuery } from "v2/store/taxSetupApi";

export const CartNavItem = () => {
  const { uuid: groupId } = useCurrentGroupContext();
  const { trackEvent } = useAnalytics();
  const cartModal = useModal();

  const { data: cartTotal } = useGetEntitiesCartTotalQuery(
    { groupId },
    { skip: !groupId }
  );

  const itemsCount = cartTotal?.total_items_count ?? 0;

  const handleClick = () => {
    trackEvent(OPEN_CHECKOUT, { type: "left_nav" });
    cartModal.open();
  };

  const countChip =
    itemsCount > 0 ? (
      <LeftBarTag type="neutral">{itemsCount}</LeftBarTag>
    ) : undefined;

  return (
    <div onClick={stopPropagation}>
      <SidebarStickyItem
        icon={ShoppingCartIcon}
        label="Cart"
        onClick={handleClick}
        suffix={countChip}
      />
      {cartModal.isOpen && (
        <CartModal open={cartModal.isOpen} onClose={cartModal.close} />
      )}
    </div>
  );
};
